import { __awaiter } from "tslib";
import { getConfig } from '@local/app-config';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { clearCombinedToken as clearAccessToken, getCombinedToken as getAccessToken, } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';
const entitlementBaseQuery = (args, WebApi, extraOptions) => __awaiter(void 0, void 0, void 0, function* () {
    const baseUrl = getConfig().entitlements_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            var _a;
            const token = (_a = getAccessToken()) === null || _a === void 0 ? void 0 : _a.access_token;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            else {
                clearAccessToken();
            }
            return headers;
        },
    });
    const result = yield rawBaseQuery(args, WebApi, extraOptions);
    if (result.error && result.error.status === 401) {
        clearAccessToken();
    }
    return result;
});
export const EntitlementsApiClient = createApi({
    reducerPath: 'entitlementsAPI',
    baseQuery: entitlementBaseQuery,
    endpoints: () => ({}),
});
//# sourceMappingURL=EntitlementsApiClient.js.map